// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ad107366","239":"d43d248e","455":"81504191"}[chunkId] + ".chunk.js";
};